export default function StreamInputDescHls({ input }) {
  return <>HLS {input.url}</>;
}
